import React, { memo, useEffect, useMemo, useState } from "react";
import styles from "./HomeLayout.module.scss";
// import LOGO from "../../assets/logo.png";
import { sideBarNavigation } from "utils/sideBarNavigation";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { PATH, PORTALS } from "utils/constants";
import { combineClasses } from "utils/utils";
import rightIcon from "assets/svg/chevron-right.svg"
import downIcon from "assets/svg/chevron-down.svg"
import deleteIcon from "assets/svg/Delete.svg"
import { useSelector, useDispatch } from "react-redux";
import { deleteStock, delfiltered, filtered, getStock, setModal } from "redux/stockSlice";
import SearchBar from "./SearchBar";
import LeftSearchBar from "components/shared/searchfield/LeftSearchBar";
import SEARCH_ICON from "../../../assets/svg/Frame.svg"
import LOGOUT_ICON from "../../../assets/png/logout.png"
import CROSS_ICON from "../../../assets/png/cross.png"

import toast from "react-hot-toast";
const LeftSideBar = () => {
  const location = useLocation();
  const dispatch = useDispatch()
  const [term, setTerm] = useState("")
  const navigate = useNavigate()
  const { stock, fil, roles, load } = useSelector((state) => state.stock)
  const sidebarObj = useMemo(() => {
    const temp = Object.keys(PORTALS)
    return temp?.length && temp.reduce((acc, item) => {
      acc[item] = false
      return acc
    }, {})
  }, [])
  const [sidebarItemsOpen, setSidebarItemsOpen] = useState(sidebarObj);
  function handleDelete(id) {
    dispatch(deleteStock(id))
    dispatch(delfiltered(id))
    navigate("/stocktrend")
    // setTerm("")

  }
  function handlechange(e) {
    const val = e.target.value
    let filtered_array = stock?.filter((stock) => stock?.symbol.toLowerCase().includes(val.toLowerCase()) || stock?.name.toLowerCase().includes(e.target.value.toLowerCase()))
    dispatch(filtered(filtered_array))
    setTerm(val)
  }
  useEffect(() => {
    // dispatch(getStock())
  }, [])
  return (
    <div className={styles.leftSideContainer}>
      <div>
        <div className={styles.logoContainer}>
          Stock Automation
        </div>
        <div className={styles.navContainer}>
          {Object.entries(PORTALS).length && Object.entries(PORTALS).filter(([key, value]) => roles?.trend && roles?.tracker ? value == "/stock" ? null : value : roles?.trend ? value == "/stocktrend" : value == "/stock/logs").map(([key, value]) => {
            return (
              <div key={key}>
                {/* {
                Object.keys(PATH[key].children).length !== 0 ?
                  <NavLink
                    to={value}
                    className={({ isActive }) =>
                      combineClasses(styles.portalNavLink, isActive ? styles.portalLinkactive : "")}
               
                  >
                    <p style={{ color: "black" }}>{key}</p>
                  
                    <img src={downIcon} alt="collapse menu" />
                  </NavLink>
                  :
                  <NavLink
                    to={value}
                    className={({ isActive }) =>
                      combineClasses(styles.portalNavLinkSingle, isActive ? styles.activeLink : "")}
                    onClick={() => setSidebarItemsOpen({ ...sidebarItemsOpen, [key]: !sidebarItemsOpen?.[key] })}
                  >
                    <p style={{ color: "black" }}>{key}</p>
                  </NavLink>
              } */}
                <NavLink
                  to={value}
                  className={({ isActive }) =>
                    combineClasses(styles.portalNavLinkSingle, isActive ? styles.activeLink : "")}
                  onClick={() => setSidebarItemsOpen({ ...sidebarItemsOpen, [key]: !sidebarItemsOpen?.[key] })}
                >
                  <p style={{ color: "black" }}>{key}</p>
                </NavLink>
                {
                  Object.keys(PATH[key].children).length !== 0 ?
                    <>
                      {/* <input type="text" onChange={handlechange} value={term} className={styles.left_search} placeholder="Search by name or symbol" /> */}
                      <div className={styles.search_container}>
                        <LeftSearchBar
                          onChange={handlechange}
                          placeholder="Search"
                          value={term}

                        />
                        <img src={SEARCH_ICON} className={styles.search_icon} />
                        {term &&
                          <img src={CROSS_ICON} className={styles.search_cross} onClick={() => {
                            dispatch(filtered(null))
                            setTerm("")
                          }} />
                        }
                      </div>
                      <div className={styles.nav_stocks}>
                        {sideBarNavigation?.[key].map((data) => (
                          <>
                            {fil.length !== 0 ?
                              fil?.map((stock) => {
                                return <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                  <NavLink
                                    key={stock.id}
                                    className={({ isActive }) =>
                                      `${styles.navLink} ${isActive && styles.activeLink}`
                                    }
                                    to={`${data?.path_id}/${stock?.id}`}
                                    state={{ previousPath: location.pathname }}
                                  >
                                    <div>
                                      {/* <img src={data?.icon} alt="" className={styles.icon} /> */}

                                      <p>{stock?.symbol}</p></div>

                                  </NavLink>

                                  <div className={styles.delete_container}>
                                    <img src={deleteIcon} onClick={() => handleDelete(stock?.id)} />
                                  </div>
                                </div>
                              })
                              :
                              stock?.map((stock) => {
                                return <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                  <NavLink
                                    key={stock.id}
                                    className={({ isActive }) =>
                                      `${styles.navLink} ${isActive && styles.activeLink}`
                                    }
                                    to={`${data?.path_id}/${stock?.id}`}
                                    state={{ previousPath: location.pathname }}
                                  >
                                    <div style={{ display: "flex" }}>

                                      {/* <img src={data?.icon} alt="" className={styles.icon} /> */}

                                      <p>{stock?.symbol}</p></div>

                                  </NavLink>

                                  <div className={styles.delete_container}>
                                    <img src={deleteIcon} onClick={() => handleDelete(stock?.id)} />
                                  </div>
                                </div>
                              })

                            }
                          </>
                        ))}
                      </div></>
                    :
                    // <>
                    //   {sideBarNavigation?.[key].map((data) => (
                    //     <>
                    //       {
                    //         stock?.map((stock) => {
                    //           return <NavLink
                    //             style={{ display: "flex" }}
                    //             key={stock.id}
                    //             className={({ isActive }) =>
                    //               `${styles.navLink} ${isActive && styles.activeLink}`
                    //             }
                    //             to={`${data?.path_id}/${stock?.id}`}
                    //             state={{ previousPath: location.pathname }}
                    //           >
                    //             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}> <img src={data?.icon} alt="" className={styles.icon} />
                    //               <p>{stock?.symbol}</p></div>
                    //             <img src={deleteIcon} onClick={() => handleDelete(stock?.id)} />
                    //           </NavLink>
                    //         })
                    //       }
                    //     </>
                    //   ))}
                    // </>
                    null
                }


              </div>
            )
          })}
        </div>

      </div>

      <div className={styles.logout_main} >
        <div style={{ display: "flex", gap: "10px", alignItems: "center", cursor: "pointer" }} onClick={() => {
          localStorage.clear()
          toast.success("Logout Successfully")
          navigate("/login")
        }}>
          <div className={styles.logoutContainer}> <img src={LOGOUT_ICON} /></div>
          <div className={styles.logout}>Log Out</div>
        </div>
      </div>

    </div>
  );
};

export default memo(LeftSideBar);